var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-job-page"},[_c('span',{staticClass:"app-job-page__sponsor"},[_vm._v("贊助")]),_c('span',{staticClass:"app-job-page__content"},[_vm._v(_vm._s(_vm.material.contents.bannerText.element))])])}
var staticRenderFns = []

export { render, staticRenderFns }